module.exports = {
          srcSet: __webpack_public_path__ + "665a588c183a3bef36cc92492d074e1c-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "665a588c183a3bef36cc92492d074e1c-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "665a588c183a3bef36cc92492d074e1c-120.png",
          toString:function(){return __webpack_public_path__ + "665a588c183a3bef36cc92492d074e1c-120.png"},
          
          width: 120,
          height: 120
        }